import { LogoInstagram as LogoInstagramSvg } from '@eventbrite/eds-iconography';
import React from 'react';

export const DEFAULT_NUMBER_OF_NEARBY_CITIES = 4;

export const ONLINE_LOCATION_SLUG = 'online';

export const TRAVEL_AND_OUTDOOR_CATEGORY_SLUG = 'travel-and-outdoor';

export const SOCIAL_TYPE_ICON_MAP: { [key: string]: React.ReactElement } = {
    instagram: <LogoInstagramSvg />,
};
